import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { requirePermission } from '@/features/auth/utils/permissionGuard';
import { PRODUCT_PERMISSIONS } from '@/constants/permissions';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { StudentEntryPage } from '@/features/productRequisition/pages/StudentEntryPage';
import { entrySheetSearchSchema } from '@/features/productRequisition/types/productRequisition.types';

export const Route = createFileRoute('/_auth/product/student-collection-projects/$projectId')({
  beforeLoad: () => requirePermission(PRODUCT_PERMISSIONS.STUDENT_PROJECT_VIEW),
  validateSearch: entrySheetSearchSchema,
  params: {
    parse: ({ projectId }) => ({ projectId: Number(projectId) }),
    stringify: ({ projectId }) => ({ projectId: String(projectId) }),
  },
  component: () => (
    <ErrorBoundary moduleName="Student Entry">
      <Suspense fallback={<PageLoader />}>
        <StudentEntryPage />
      </Suspense>
    </ErrorBoundary>
  ),
});
